const scrollButtons = document.querySelectorAll('.enable-scroll-js');

scrollButtons.forEach(item => {
  item.addEventListener('click', (e) => {
    e.preventDefault();

    const targetElement = document.querySelector('.video-banner-section-scroll-js');

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  })
});